import { useQuery } from '@tanstack/react-query';
import {
  getOrgAdminCatalog,
  OrgAdminCatalogItem,
} from '@/services/admin/get-org-admin-catalog';

export const useGetOrgAdminCatalog = (orgId?: string) => {
  return useQuery<OrgAdminCatalogItem[]>({
    queryKey: ['org-admin-catalog', orgId],
    queryFn: () => getOrgAdminCatalog(orgId!),
    enabled: !!orgId,
  });
};
